import * as classnames from "classnames";
import * as React from "react";

import { JumpTo, Modal, Msg } from "@shared/components";
import { ChallengeTakenBy } from "@shared/services/enums";
import Message from "@shared/services/message";

/**
 * Prop interface
 */
export interface CompletedProps {
  isOpen: boolean;
  type: string;
  onClose: () => void;
}

/**
 * React Component
 */
export default function Completed({ type, isOpen, onClose }: CompletedProps) {
  const rootStyle = classnames("code-c-completed");

  const { title, contents } = React.useMemo(() => {
    if (type.startsWith("SwitchTakenBy")) {
      const hasSwitchedToCLI =
        type === `SwitchTakenBy:${ChallengeTakenBy.LocalMachine}`;

      return {
        title: <Msg id={"completed.switchTakenBy.title"} />,
        contents: hasSwitchedToCLI ? (
          <>
            <Msg id="completed.switchTakenBy.subtitle" />
            <Msg id="completed.switchTakenBy.body1" />
            <pre>
              <code>track clone {`${window.location.href}`}</code>
            </pre>
            <Msg id="completed.switchTakenBy.body2" />
            <pre>
              <code>track pull</code>
            </pre>
            <Msg id="completed.switchTakenBy.document" />
            <ul className="code-c-completed__docs">
              <li>
                <div className="code-c-completed__doc-item">
                  <Msg id="start-challenge.local.option.linkToDoc" />
                  <span>
                    <JumpTo
                      to={Message.getMessageByKeyAndLocale(
                        "editor.link.coding.cli",
                        "ja",
                      )}
                    >
                      [日本語]
                    </JumpTo>
                  </span>
                  <span>
                    <JumpTo
                      to={Message.getMessageByKeyAndLocale(
                        "editor.link.coding.cli",
                        "en",
                      )}
                    >
                      [English]
                    </JumpTo>
                  </span>
                </div>
              </li>
              <li>
                <div className="code-c-completed__doc-item">
                  <Msg id="start-challenge.local.option.linkToInstall" />
                  <span>
                    <JumpTo
                      to={Message.getMessageByKeyAndLocale(
                        "editor.link.coding.cli.install",
                        "ja",
                      )}
                    >
                      [日本語]
                    </JumpTo>
                  </span>
                  <span>
                    <JumpTo
                      to={Message.getMessageByKeyAndLocale(
                        "editor.link.coding.cli.install",
                        "en",
                      )}
                    >
                      [English]
                    </JumpTo>
                  </span>
                </div>
              </li>
            </ul>
          </>
        ) : (
          <p>
            <Msg id="completed.switchTakenBy.subtitle" />
          </p>
        ),
      };
    }

    return {
      title: <Msg id={"completed.title"} />,
      contents: <Msg id={"completed.body"} />,
    };
  }, [type]);

  return (
    <Modal
      title={title}
      className={rootStyle}
      isOpen={isOpen}
      hasCancelButton={false}
      onClickOk={onClose}
      onClose={onClose}
      ariaLabel="Switch Taken By Complete"
    >
      <div className="code-c-completed__body">{contents}</div>
    </Modal>
  );
}
